import { useEffect, useState } from "react";
import { Phone, Trash2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = [
    { value: "new", label: "Nouvelle" },
    { value: "called", label: "Rappelée" },
    { value: "done", label: "Traitée" },
];

export default function AdminCallbacks() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        try {
            const { data } = await api.get("/admin/callbacks");
            setItems(data);
        } catch (e) {
            toast.error(formatApiError(e));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    const updateStatus = async (id, status) => {
        try {
            const { data } = await api.patch(`/admin/callbacks/${id}`, { status });
            setItems(items.map((x) => (x.id === id ? data : x)));
            toast.success("Statut mis à jour");
        } catch (e) {
            toast.error(formatApiError(e));
        }
    };

    const remove = async (item) => {
        if (!window.confirm(`Supprimer la demande de ${item.first_name} ?`)) return;
        await api.delete(`/admin/callbacks/${item.id}`);
        setItems(items.filter((i) => i.id !== item.id));
    };

    return (
        <div className="p-10" data-testid="admin-callbacks-page">
            <span className="overline">Espace admin</span>
            <h1 className="mt-3 font-serif text-4xl text-brand-ink font-light">Demandes de rappel</h1>

            {loading ? (
                <p className="mt-12 text-brand-sageDark">Chargement…</p>
            ) : items.length === 0 ? (
                <div className="mt-12 py-16 text-center bg-brand-bgalt border border-brand-border">
                    <p className="font-serif text-xl text-brand-ink italic">Aucune demande de rappel.</p>
                </div>
            ) : (
                <div className="mt-10 bg-brand-bgalt border border-brand-border divide-y divide-brand-border">
                    {items.map((c) => (
                        <div key={c.id} className="p-5 grid md:grid-cols-12 gap-4 items-center">
                            <div className="md:col-span-3">
                                <p className="font-serif text-lg text-brand-ink">{c.first_name}</p>
                                <a href={`tel:${c.phone}`} className="text-sm text-brand-sage hover:underline flex items-center gap-1 mt-0.5">
                                    <Phone size={12} /> {c.phone}
                                </a>
                            </div>
                            <div className="md:col-span-3 text-sm text-brand-sageDark">
                                {c.preferred_time || "—"}
                            </div>
                            <div className="md:col-span-3 text-xs text-brand-sageDark">
                                {new Date(c.created_at).toLocaleString("fr-FR")}
                            </div>
                            <div className="md:col-span-2">
                                <select
                                    value={c.status}
                                    onChange={(e) => updateStatus(c.id, e.target.value)}
                                    className="text-xs uppercase tracking-[0.16em] px-2 py-1.5 border border-brand-border bg-transparent w-full"
                                >
                                    {STATUSES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
                                </select>
                            </div>
                            <div className="md:col-span-1 text-right">
                                <button onClick={() => remove(c)} className="p-2 hover:bg-red-50 text-red-700">
                                    <Trash2 size={14} />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
